import MultiSelect from "discourse/select-kit/components/multi-select";
import FormFieldComboBox from "./combo-box";
import FormFieldWireFrame from "./wire-frame";

export default class FormFieldMultiSelect extends FormFieldComboBox {
  <template>
    <FormFieldWireFrame
      @fieldName={{this.fieldName}}
      @title={{this.title}}
      @description={{this.description}}
      @required={{@required}}
      @validation={{@validation}}
    >
      <MultiSelect
        class="circles-form-{{@name}}"
        ...attributes
        name={{this.fieldName}}
        @nameProperty={{this.nameProperty}}
        @valueProperty={{this.valueProperty}}
        @value={{@value}}
        @none={{@noneI18n}}
        @content={{@content}}
        @onChange={{@onChange}}
        @options={{this.options}}
      />
      {{yield}}
    </FormFieldWireFrame>
  </template>
}
